export default __webpack_public_path__ + "static/media/tag-light.a5ccbe88.svg";